<mat-tab 
  [label]="label"
  [disabled]='disabled'
>
  <custom-page-viewer *ngIf="customPage"
    [customPage]="customPage" 
    [masterId]="masterId" 
    [hideTitle]="true" 
    [readOnly]="readOnly"
    [(isDirty)]="isDirty"
  >
  </custom-page-viewer>

  <ng-content *ngIf="!customPage"></ng-content>
</mat-tab>
